import { Component } from '@angular/core';

@Component({
  selector: 'opac-table-cell-text',
  templateUrl: './table-cell-text.component.html',
  styleUrls: ['./table-cell-text.component.scss']
})
export class TableCellTextComponent {
}
